"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatusTimeline = void 0;
var lodash_1 = require("lodash");
function useStatusTimeline(_a) {
    var timelineItemConfigs = _a.timelineItemConfigs, currentItemKey = _a.currentItemKey, reversed = _a.reversed, small = _a.small, highlightCurrentStep = _a.highlightCurrentStep;
    var filteredItems = timelineItemConfigs.filter(function (item) { return !(item.hideIfNotActive && item.key !== currentItemKey); });
    var displayedKeys = filteredItems.map(function (item) { return item.key; });
    var lastIndex = filteredItems.length - 1;
    var selectedIndex = currentItemKey ? displayedKeys.indexOf(currentItemKey) : -1;
    var allItemsInactive = selectedIndex < 0 || filteredItems[selectedIndex].isInactiveState || false;
    var displayedItems = filteredItems.map(function (item, index) {
        var isFirstElement = index === 0;
        var isLastElement = index === lastIndex;
        var isActive = !allItemsInactive && selectedIndex >= index;
        var isNextActive = !allItemsInactive && selectedIndex > index;
        return __assign(__assign({}, item), { allItemsInactive: allItemsInactive, isActive: isActive, small: small, isTopElement: reversed ? isLastElement : isFirstElement, isTopConnectorActive: reversed ? isNextActive : isActive, isBottomConnectorActive: reversed ? isActive : isNextActive, isHighlighted: highlightCurrentStep && index === selectedIndex, isBottomElement: reversed ? isFirstElement : isLastElement });
    });
    return {
        displayedItems: reversed ? (0, lodash_1.reverse)(displayedItems) : displayedItems,
    };
}
exports.useStatusTimeline = useStatusTimeline;
